import { render, staticRenderFns } from "./NotificationEventsList.vue?vue&type=template&id=c518d968&scoped=true"
import script from "./NotificationEventsList.vue?vue&type=script&lang=ts"
export * from "./NotificationEventsList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationEventsList.vue?vue&type=style&index=0&id=c518d968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c518d968",
  null
  
)

export default component.exports